import { jwtDecode } from 'jwt-decode';
import type { z } from 'zod';

import { logException } from '../../lib/logger/logger';

export const parseTokenInfo = <TSchema extends z.ZodSchema>(
	token: string,
	schema: TSchema,
): z.infer<TSchema> | undefined => {
	try {
		const decodedInfo = jwtDecode(token);
		return schema.parse(decodedInfo);
	} catch (e) {
		logException(e);
		return undefined;
	}
};
